import _clone from 'lodash/clone';
import state from '@/store/hoPaginatedList/state';

export default { ..._clone(state), channel: null, requestId: 0 };
